//import React from 'react';
import { connect } from 'react-redux';
import HeaderShareResumeComponent from '../components/common/HeaderShareResumeComponent';
import Cookie from 'js-cookie';

const mapStateToProps = (state, ownProps) => {
    return { user: state.user, loginHash: Cookie.get('rbuser')};
};

const HeaderShareResumeContainer = connect(mapStateToProps)(HeaderShareResumeComponent);
export default HeaderShareResumeContainer;
